<template>
  <section class="pagination">
    <el-pagination @current-change="handleCurrentChange"
                   :page-size="pageSize"
                   :page-sizes="sizes"
                   :current-page.sync="page"
                   layout="total, sizes, prev, pager, next"
                   :total="total">
    </el-pagination>
  </section>
</template>

<script>
export default {
  name: 'pagination',
  props: {
    currentPage: {
      default: 1,
      type: Number,
    },
    total: {
      default: 0,
      type: Number,
    },
    sizes: {
      default: () => [20],
      type: Array,
    },
    pageSize: {
      default: 20,
      type: Number,
    },
  },
  data() {
    return {
      page: this.currentPage,
    };
  },
  methods: {
    handleCurrentChange(page) {
      this.$emit('changePage', page);
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 0;
}
//   ::v-deep .el-pager li.active {
//     color: #6776F5;
//   }
//   ::v-deep .el-pager li:hover {
//     color: #6776F5;
//   }
</style>
